module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e0f359ce2f5ad60b443bdb153a076f56.png";